module.exports = __webpack_public_path__ + "static/00022.ee879296.jpg";